import { ClipboardJS, Swal } from "./vendor";
import { ajaxPost, parceAjaxErrorResponse } from "./js/utils";
import { bsToast } from "./js/plugins";
import { Tooltip } from "bootstrap";
import "./js/common";
import "./js/travel";
import "./js/transport";
import "./js/property";
import "./js/casco";
import "./js/extra_compulsory";

let jsContext = {};
const jsContextJson = $("#js_context");
if (jsContextJson.length > 0) {
  jsContext = JSON.parse(jsContextJson.text());
}

export const getJsContext = (key) => {
  if (!(key in jsContext)) {
    return key;
  }
  return jsContext[key];
};

export const getUrlTranslation = (url) => {
  const lang = document.querySelector("html").getAttribute("lang");
  if (lang === "az") {
    return url;
  }

  return `/${lang}${url}`;
};

export const WimsSwal = Swal.mixin({
  customClass: {
    title: "ms-2",
    actions: "ps-2",
    confirmButton: "btn btn-primary px-5 m-2",
    cancelButton: "btn btn-secondary px-5 m-2",
    denyButton: "btn btn-secondary px-5 m-2",
  },
  buttonsStyling: false,
  heightAuto: false,
});

export const SwalPost = (url, data, options = {}) => {
  return new Promise((resolve, reject) => {
    WimsSwal.fire({
      text: getJsContext("are_you_sure_to_perform_this_action"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: getJsContext("yes_perform"),
      cancelButtonText: getJsContext("no_cancel"),
      heightAuto: false,
      ...options,
    }).then((result) => {
      if (result.isConfirmed) {
        WimsSwal.fire({
          icon: "info",
          text: getJsContext("please_wait") + "...",
        });
        ajaxPost(url, data)
          .then((response) => {
            resolve(response);
          })
          .catch((errors) => {
            const errorList = parceAjaxErrorResponse(errors);
            ErrorSwal.fire({ html: errorList.join("<br>") }).then(() => {
              reject(errors);
            });
          })
          .finally(() => {
            Swal.close;
          });
      } else {
        reject('Swal: "No, cancel" button clicked.');
      }
    });
  });
};

export const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  buttonsStyling: false,
  timer: 3000,
  timerProgressBar: true,
  customClass: {
    title: "ms-2",
    actions: "ps-2",
    confirmButton: "btn btn-primary px-5 m-2",
    cancelButton: "btn btn-secondary px-5 m-2",
    denyButton: "btn btn-secondary px-5 m-2",
  },
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
    toast.addEventListener("click", Swal.close);
  },
});

export const SuccessSwal = WimsSwal.mixin({
  icon: "success",
  text: getJsContext("operation_successfully_performed"),
});

export const ErrorSwal = WimsSwal.mixin({
  icon: "error",
  titleText: getJsContext("error_occurred"),
  text: getJsContext("error_occurred_on_request_to_server"),
});

export const AlertSwal = WimsSwal.mixin({
  showCancelButton: true,
  confirmButtonText: getJsContext("yes_perform"),
  cancelButtonText: getJsContext("no_cancel"),
});

export const SuccessToast = WimsSwal.mixin({
  // title: 'Əla!',
  text: getJsContext("operation_successfully_performed"),
  icon: "success",
  toast: true,
  position: "bottom-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
    toast.addEventListener("mouseclick", Swal.close);
  },
});

window.addEventListener("offline", () => {
  $("#connectivity").remove();
  $("body").append(
    `<div id="connectivity" class="offline">${getJsContext(
      "no_internet_connection",
    )}</div>`,
  );
});

window.addEventListener("online", () => {
  $("#connectivity").remove();
  $("body").append(
    `<div id="connectivity" class="online">${getJsContext(
      "internet_connection_restored",
    )}</div>`,
  );
  setTimeout(() => {
    $("#connectivity").fadeOut(500, () => {
      $("#connectivity").remove();
    });
  }, 3000);
});

$("body")
  .find('[data-bs-toggle="tooltip"]')
  .each((_, el) => {
    new Tooltip(el);
  });

new ClipboardJS("button.clipboard").on("success", function (e) {
  bsToast({
    title: getJsContext("copied"),
    content: getJsContext("text_copied") + ": " + e.text,
  });

  e.clearSelection();
});

const clearableInput = $(".input-clearable");
if (clearableInput.length) {
  const toggleClearInput = (input) => {
    if (input.val().length !== 0) {
      input.closest("div").find("button.clear-input").fadeIn();
    } else {
      input.closest("div").find("button.clear-input").hide();
    }
  };

  clearableInput.each((_, el) => {
    $(el)
      .closest("div")
      .append(
        `<button class="clear-input" type="button" style="display: none;">×</button>`,
      );
    toggleClearInput($(el));
  });

  clearableInput.on("input", (e) => {
    toggleClearInput($(e.target));
  });

  clearableInput
    .closest("div")
    .find("button.clear-input")
    .on("click", (e) => {
      $(e.target).closest("div").find("input").val("").focus();
      $(e.target).hide();
    });
}

// initialize jquery plugins
// use this function to initialize plugins after ajax calls (for example after modal content loaded)
export const initPlugins = (parent = null) => {
  if (!parent) {
    parent = $("body");
  } else {
    parent = $(parent);
  }

  parent
    .find(".select2")
    .select2({
      minimumResultsForSearch: -1,
      placeholder: {
        id: "",
        text: getJsContext("select_one"),
      },
    })
    .on("select2:open", function (e) {
      $(".select2-dropdown").hide();
      setTimeout(function () {
        $(".select2-dropdown").addClass("select2-animate-open").show();
      });
    });

  parent.find(".form-control-datepicker").flatpickr({
    dateFormat: "d.m.Y",
    allowInput: true,
    disableMobile: true,
    // enableTime: true,
    time_24hr: true,
    // inline: true,
  });

  parent.find(".form-control-timepicker").flatpickr({
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i:ss",
    time_24hr: true,
  });

  parent.find(".form-control-datetimepicker").flatpickr({
    enableTime: true,
    dateFormat: "d.m.Y H:i",
    time_24hr: true,
  });

  parent.find(".form-control-range-datepicker").flatpickr({
    dateFormat: "d.m.Y",
    allowInput: true,
    mode: "range",
  });

  parent.find('[data-bs-toggle="tooltip"]').each((_, el) => {
    new Tooltip(el);
  });
};

initPlugins();
